export default function Avatar(theme) {
  return {
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: theme.palette.text.primary,
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }
      }
    }
  };
} 